import { FramingSelection } from '../types';
import {
  getFramePrice,
  parseVariantTitle,
  STANDARD_MOUNTING,
} from './framePricing';

/**
 * Presentational props derived from a frame selection (framed / unframed /
 * pending).
 */
export const selectionSummaryProps = (
  selection: FramingSelection,
  framedByDefault: boolean,
) => {
  if (selection === undefined) return { state: 'pending' as const };
  if (selection === null) return { state: 'unframed' as const };

  const { glazing, mounting } = parseVariantTitle(selection.variant.title);

  return {
    state: 'framed' as const,
    frameName: selection.title,
    glazingName: glazing,
    mountingName: mounting === STANDARD_MOUNTING ? undefined : mounting,
    price: getFramePrice(selection),
    included: framedByDefault,
  };
};
